import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import styles from './LanguageToggle.module.css';

const LanguageToggle = ({ transparent = false }) => {
  const { language, setLanguage } = useTranslation();

  const handleToggle = () => {
    setLanguage(language === 'fr' ? 'en' : 'fr');
  };

  const buttonClasses = `${styles.languageToggle} ${transparent ? styles.transparent : ''}`;

  return (
    <button
      onClick={handleToggle}
      className={buttonClasses}
      aria-label={`Switch to ${language === 'fr' ? 'English' : 'French'}`}
    >
      {language === 'fr' ? 'EN' : 'FR'}
    </button>
  );
};

export default LanguageToggle;
